// src/pages/Profile.jsx
import React from 'react';
import ProfileContainer from '../../components/Profile/ProfileContainer';

const Profile = () => {

  return (
    <>
      <ProfileContainer />
    </>
  );
};

export default Profile;
